module.exports = __webpack_public_path__ + "static/img/pagebg.8fd3881.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pagebg.png
// module id = LOz4
// module chunks = 1